module.exports = __webpack_public_path__ + "img/rosepetal-dep-calvo.e12ef04b.jpg";